(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[8],{

/***/ "A926":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ useUserInfo; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/swr/esm/index.js + 8 modules
var esm = __webpack_require__("VtrM");

// CONCATENATED MODULE: ./typescript/enums/backend/userEnums.ts
var SignUpMethods;

(function (SignUpMethods) {
  SignUpMethods["Leaf"] = "leaf";
  SignUpMethods["Google"] = "google";
})(SignUpMethods || (SignUpMethods = {}));
// CONCATENATED MODULE: ./lib/useUserInfo.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var myRequest = function myRequest(requestedAPI) {
  return {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json"
    }),
    body: JSON.stringify({
      requestedAPI: requestedAPI
    })
  };
};

var userInfoFetcher = function userInfoFetcher() {
  return fetch("api/endpoint", myRequest("get_userInfo")).then(function (res) {
    return res.json();
  });
};

function useUserInfo(authenticated) {
  var initialUserInfo = {
    about: "",
    email: "",
    emailVerified: false,
    github: "",
    method: SignUpMethods.Leaf,
    twitter: "",
    uid: "",
    userHost: "",
    username: "",
    website: "",
    following: []
  };
  /* Settings-Related State */

  var _useState = Object(react["useState"])(""),
      newUsername = _useState[0],
      changeNewUsername = _useState[1];

  var _useState2 = Object(react["useState"])(""),
      newEmail = _useState2[0],
      changeNewEmail = _useState2[1];

  var _useState3 = Object(react["useState"])(""),
      newPassword = _useState3[0],
      changeNewPassword = _useState3[1];

  var _useState4 = Object(react["useState"])(""),
      password = _useState4[0],
      updatePassword = _useState4[1];

  var _useState5 = Object(react["useState"])(false),
      changeUsernameLoading = _useState5[0],
      updateChangeUsernameLoading = _useState5[1];

  var _useState6 = Object(react["useState"])(""),
      userNameError = _useState6[0],
      updateUserNameError = _useState6[1];

  var _useState7 = Object(react["useState"])(""),
      emailError = _useState7[0],
      updateEmailError = _useState7[1];

  var _useState8 = Object(react["useState"])(""),
      passwordStatus = _useState8[0],
      updatePasswordStatus = _useState8[1];

  var _useState9 = Object(react["useState"])(""),
      emailAndPasswordStatus = _useState9[0],
      updateEmailAndPasswordStatus = _useState9[1];

  var _useState10 = Object(react["useState"])(""),
      sendEmailVerificationStatus = _useState10[0],
      updateSendEmailVerificationStatus = _useState10[1];
  /* Profile-Related State */


  var _useState11 = Object(react["useState"])(""),
      about = _useState11[0],
      changeAbout = _useState11[1];

  var _useState12 = Object(react["useState"])(""),
      twitter = _useState12[0],
      changeTwitter = _useState12[1];

  var _useState13 = Object(react["useState"])(""),
      github = _useState13[0],
      changeGithub = _useState13[1];

  var _useState14 = Object(react["useState"])(""),
      website = _useState14[0],
      changeWebsite = _useState14[1];

  var _useSWR = Object(esm["a" /* default */])(authenticated ? "getUserInfo" : null, userInfoFetcher, {
    initialData: initialUserInfo,
    revalidateOnMount: true
  }),
      data = _useSWR.data,
      mutate = _useSWR.mutate;

  var userInfo = data || initialUserInfo;
  var emailVerified = userInfo.emailVerified,
      method = userInfo.method,
      email = userInfo.email,
      username = userInfo.username,
      userHost = userInfo.userHost,
      following = userInfo.following,
      uid = userInfo.uid;

  function saveNewProfile() {
    return _saveNewProfile.apply(this, arguments);
  }

  function _saveNewProfile() {
    _saveNewProfile = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var changeProfileRequest;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              changeProfileRequest = {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json"
                }),
                body: JSON.stringify({
                  requestedAPI: "set_userProfile",
                  about: about,
                  twitter: twitter,
                  github: github,
                  website: website
                })
              };
              _context.next = 3;
              return fetch("api/endpoint", changeProfileRequest).then(function (res) {})["catch"](function (error) {
                console.log(error);
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _saveNewProfile.apply(this, arguments);
  }

  function saveNewUsername() {
    return _saveNewUsername.apply(this, arguments);
  }

  function _saveNewUsername() {
    _saveNewUsername = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var changeUsernameRequest, updateUsernameResponse;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              changeUsernameRequest = {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json"
                }),
                body: JSON.stringify({
                  requestedAPI: "set_userId",
                  username: newUsername
                })
              };
              updateChangeUsernameLoading(true);
              _context2.next = 4;
              return fetch("api/endpoint", changeUsernameRequest).then(function (res) {
                return res.json();
              });

            case 4:
              updateUsernameResponse = _context2.sent;

              if (!updateUsernameResponse.error) {
                updateUserNameError("");
                mutate(_objectSpread(_objectSpread({}, userInfo), {}, {
                  username: newUsername
                }), true);
              } else {
                updateUserNameError(updateUsernameResponse.error);
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _saveNewUsername.apply(this, arguments);
  }

  function saveNewEmail() {
    return _saveNewEmail.apply(this, arguments);
  }

  function _saveNewEmail() {
    _saveNewEmail = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var changeEmailRequest;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              changeEmailRequest = {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json"
                }),
                body: JSON.stringify({
                  requestedAPI: "set_userEmail",
                  email: newEmail
                })
              };
              _context3.next = 3;
              return fetch("/api/endpoint", changeEmailRequest).then(function (res) {
                if (res.status === 200) {
                  mutate(_objectSpread(_objectSpread({}, userInfo), {}, {
                    email: newEmail
                  }), true);
                  updateEmailError("");
                  sendEmailVerification();
                }

                if (res.status === 403) {
                  res.json().then(function (resJson) {
                    updateEmailError(resJson.error);
                  });
                }
              })["catch"](function (error) {
                console.log(error);
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _saveNewEmail.apply(this, arguments);
  }

  function saveNewPassword() {
    return _saveNewPassword.apply(this, arguments);
  }

  function _saveNewPassword() {
    _saveNewPassword = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var changePasswordRequest;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              changePasswordRequest = {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json"
                }),
                body: JSON.stringify({
                  requestedAPI: "set_userPassword",
                  password: password,
                  newPassword: newPassword
                })
              };
              _context4.next = 3;
              return fetch("/api/endpoint", changePasswordRequest).then(function (res) {
                if (res.status === 200) {
                  updatePasswordStatus("Password was successfully reset");
                }

                if (res.status === 403) {
                  res.json().then(function (resJson) {
                    updatePasswordStatus(resJson.error);
                  });
                }
              })["catch"](function (error) {
                console.log(error);
              });

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _saveNewPassword.apply(this, arguments);
  }

  function saveNewEmailAndPassword() {
    return _saveNewEmailAndPassword.apply(this, arguments);
  }

  function _saveNewEmailAndPassword() {
    _saveNewEmailAndPassword = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var saveEmailAndPasswordRequest;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              saveEmailAndPasswordRequest = {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json"
                }),
                body: JSON.stringify({
                  requestedAPI: "set_email_and_password",
                  newPassword: newPassword,
                  newEmail: newEmail
                })
              };
              _context5.next = 3;
              return fetch("/api/endpoint", saveEmailAndPasswordRequest).then(function (res) {
                if (res.status === 200) {
                  mutate(_objectSpread(_objectSpread({}, userInfo), {}, {
                    method: SignUpMethods.Leaf
                  }), true);
                  updateEmailAndPasswordStatus("Email & password were successfully reset");
                  sendEmailVerification();
                }

                if (res.status === 403) {
                  res.json().then(function (resJson) {
                    updateEmailAndPasswordStatus(resJson.error);
                  });
                }
              })["catch"](function (error) {
                console.log(error);
              });

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _saveNewEmailAndPassword.apply(this, arguments);
  }

  function sendEmailVerification() {
    return _sendEmailVerification.apply(this, arguments);
  }

  function _sendEmailVerification() {
    _sendEmailVerification = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var sendEmailVerificationRequest;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              sendEmailVerificationRequest = {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json"
                }),
                body: JSON.stringify({
                  requestedAPI: "sendEmailVerification"
                })
              };
              _context6.next = 3;
              return fetch("/api/endpoint", sendEmailVerificationRequest).then(function (res) {
                if (res.status === 200) {
                  updateSendEmailVerificationStatus("Verification email sent");
                }

                if (res.status === 403) {
                  res.json().then(function (resJson) {
                    updateSendEmailVerificationStatus(resJson.error);
                  });
                }
              })["catch"](function (error) {
                console.log(error);
              });

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _sendEmailVerification.apply(this, arguments);
  }

  return {
    username: username,
    email: email,
    password: password,
    updatePassword: updatePassword,
    saveNewUsername: saveNewUsername,
    saveNewEmail: saveNewEmail,
    saveNewPassword: saveNewPassword,
    saveNewEmailAndPassword: saveNewEmailAndPassword,
    newUsername: newUsername,
    newEmail: newEmail,
    newPassword: newPassword,
    changeNewUsername: changeNewUsername,
    changeNewEmail: changeNewEmail,
    changeNewPassword: changeNewPassword,
    changeUsernameLoading: changeUsernameLoading,
    userNameError: userNameError,
    emailError: emailError,
    passwordStatus: passwordStatus,
    emailAndPasswordStatus: emailAndPasswordStatus,
    emailVerified: emailVerified,
    sendEmailVerification: sendEmailVerification,
    sendEmailVerificationStatus: sendEmailVerificationStatus,
    signInMethod: method,
    about: about,
    twitter: twitter,
    github: github,
    website: website,
    changeAbout: changeAbout,
    changeTwitter: changeTwitter,
    changeGithub: changeGithub,
    changeWebsite: changeWebsite,
    saveNewProfile: saveNewProfile,
    userHost: userHost,
    following: following,
    uid: uid
  };
}

/***/ }),

/***/ "HaE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "Wgwc":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(this,function(){"use strict";var t="millisecond",e="second",n="minute",r="hour",i="day",s="week",u="month",a="quarter",o="year",f="date",h=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d+)?$/,c=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,d={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},$=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},l={s:$,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+$(r,2,"0")+":"+$(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,u),s=n-i<0,a=e.clone().add(r+(s?-1:1),u);return+(-(r+(n-i)/(s?i-a:a-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return{M:u,y:o,w:s,d:i,D:f,h:r,m:n,s:e,ms:t,Q:a}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},y="en",M={};M[y]=d;var m=function(t){return t instanceof S},D=function(t,e,n){var r;if(!t)return y;if("string"==typeof t)M[t]&&(r=t),e&&(M[t]=e,r=t);else{var i=t.name;M[i]=t,r=i}return!n&&r&&(y=r),r||!n&&y},v=function(t,e){if(m(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new S(n)},g=l;g.l=D,g.i=m,g.w=function(t,e){return v(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var S=function(){function d(t){this.$L=D(t.locale,null,!0),this.parse(t)}var $=d.prototype;return $.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(g.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(h);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},$.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},$.$utils=function(){return g},$.isValid=function(){return!("Invalid Date"===this.$d.toString())},$.isSame=function(t,e){var n=v(t);return this.startOf(e)<=n&&n<=this.endOf(e)},$.isAfter=function(t,e){return v(t)<this.startOf(e)},$.isBefore=function(t,e){return this.endOf(e)<v(t)},$.$g=function(t,e,n){return g.u(t)?this[e]:this.set(n,t)},$.unix=function(){return Math.floor(this.valueOf()/1e3)},$.valueOf=function(){return this.$d.getTime()},$.startOf=function(t,a){var h=this,c=!!g.u(a)||a,d=g.p(t),$=function(t,e){var n=g.w(h.$u?Date.UTC(h.$y,e,t):new Date(h.$y,e,t),h);return c?n:n.endOf(i)},l=function(t,e){return g.w(h.toDate()[t].apply(h.toDate("s"),(c?[0,0,0,0]:[23,59,59,999]).slice(e)),h)},y=this.$W,M=this.$M,m=this.$D,D="set"+(this.$u?"UTC":"");switch(d){case o:return c?$(1,0):$(31,11);case u:return c?$(1,M):$(0,M+1);case s:var v=this.$locale().weekStart||0,S=(y<v?y+7:y)-v;return $(c?m-S:m+(6-S),M);case i:case f:return l(D+"Hours",0);case r:return l(D+"Minutes",1);case n:return l(D+"Seconds",2);case e:return l(D+"Milliseconds",3);default:return this.clone()}},$.endOf=function(t){return this.startOf(t,!1)},$.$set=function(s,a){var h,c=g.p(s),d="set"+(this.$u?"UTC":""),$=(h={},h[i]=d+"Date",h[f]=d+"Date",h[u]=d+"Month",h[o]=d+"FullYear",h[r]=d+"Hours",h[n]=d+"Minutes",h[e]=d+"Seconds",h[t]=d+"Milliseconds",h)[c],l=c===i?this.$D+(a-this.$W):a;if(c===u||c===o){var y=this.clone().set(f,1);y.$d[$](l),y.init(),this.$d=y.set(f,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},$.set=function(t,e){return this.clone().$set(t,e)},$.get=function(t){return this[g.p(t)]()},$.add=function(t,a){var f,h=this;t=Number(t);var c=g.p(a),d=function(e){var n=v(h);return g.w(n.date(n.date()+Math.round(e*t)),h)};if(c===u)return this.set(u,this.$M+t);if(c===o)return this.set(o,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(f={},f[n]=6e4,f[r]=36e5,f[e]=1e3,f)[c]||1,l=this.$d.getTime()+t*$;return g.w(l,this)},$.subtract=function(t,e){return this.add(-1*t,e)},$.format=function(t){var e=this;if(!this.isValid())return"Invalid Date";var n=t||"YYYY-MM-DDTHH:mm:ssZ",r=g.z(this),i=this.$locale(),s=this.$H,u=this.$m,a=this.$M,o=i.weekdays,f=i.months,h=function(t,r,i,s){return t&&(t[r]||t(e,n))||i[r].substr(0,s)},d=function(t){return g.s(s%12||12,t,"0")},$=i.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:g.s(a+1,2,"0"),MMM:h(i.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:g.s(this.$D,2,"0"),d:String(this.$W),dd:h(i.weekdaysMin,this.$W,o,2),ddd:h(i.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:g.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:g.s(u,2,"0"),s:String(this.$s),ss:g.s(this.$s,2,"0"),SSS:g.s(this.$ms,3,"0"),Z:r};return n.replace(c,function(t,e){return e||l[t]||r.replace(":","")})},$.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},$.diff=function(t,f,h){var c,d=g.p(f),$=v(t),l=6e4*($.utcOffset()-this.utcOffset()),y=this-$,M=g.m(this,$);return M=(c={},c[o]=M/12,c[u]=M,c[a]=M/3,c[s]=(y-l)/6048e5,c[i]=(y-l)/864e5,c[r]=y/36e5,c[n]=y/6e4,c[e]=y/1e3,c)[d]||y,h?M:g.a(M)},$.daysInMonth=function(){return this.endOf(u).$D},$.$locale=function(){return M[this.$L]},$.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=D(t,e,!0);return r&&(n.$L=r),n},$.clone=function(){return g.w(this.$d,this)},$.toDate=function(){return new Date(this.valueOf())},$.toJSON=function(){return this.isValid()?this.toISOString():null},$.toISOString=function(){return this.$d.toISOString()},$.toString=function(){return this.$d.toUTCString()},d}(),p=S.prototype;return v.prototype=p,[["$ms",t],["$s",e],["$m",n],["$H",r],["$W",i],["$M",u],["$y",o],["$D",f]].forEach(function(t){p[t[1]]=function(e){return this.$g(e,t[0],t[1])}}),v.extend=function(t,e){return t.$i||(t(e,S,v),t.$i=!0),v},v.locale=D,v.isDayjs=m,v.unix=function(t){return v(1e3*t)},v.en=M[y],v.Ls=M,v.p={},v});


/***/ }),

/***/ "rePB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "yfm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useFeed; });
/* unused harmony export usePosts */
/* unused harmony export goToPost */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return goToPostFromExplore; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VtrM");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("20a2");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






var myRequest = function myRequest(requestedAPI) {
  return {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json"
    }),
    body: JSON.stringify({
      requestedAPI: requestedAPI
    })
  };
};

var postsFetcher = function postsFetcher() {
  return fetch("api/endpoint", myRequest("getPosts")).then(function (res) {
    return res.json();
  });
};

var feedFetcher = function feedFetcher() {
  return fetch("api/endpoint", myRequest("getFeed")).then(function (res) {
    return res.json();
  });
};

function useFeed(authenticated) {
  var initialFeedData = [];

  var _useSWR = Object(swr__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(authenticated ? "getFeed" : [null], feedFetcher, {
    initialData: initialFeedData,
    revalidateOnMount: true
  }),
      data = _useSWR.data;

  var feed = data || [];
  return {
    feed: feed
  };
}
function usePosts(authenticated) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      postsEditClicked = _useState[0],
      changeEditClicked = _useState[1];

  var initialPostsData = [];

  var _useSWR2 = Object(swr__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(authenticated ? "getPosts" : [null], postsFetcher, {
    initialData: initialPostsData,
    revalidateOnMount: true
  }),
      data = _useSWR2.data;

  var posts = data || []; // Deprecated

  function deletePost(postUid) {
    function removeSpecificPost() {
      var searchIndex = 0;

      for (var i = 0; i < posts.length; i++) {
        if (posts[i].postId === postUid) {
          searchIndex = i;
          break;
        }
      }

      var clonePosts = posts === null || posts === void 0 ? void 0 : posts.slice();
      clonePosts.splice(searchIndex, 1);
      Object(swr__WEBPACK_IMPORTED_MODULE_3__[/* mutate */ "b"])("getPosts", clonePosts, false);
    }

    var requestBody = {
      requestedAPI: "deletePost",
      postUid: postUid
    };
    var myRequest = {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(requestBody)
    };
    removeSpecificPost();
    fetch("/api/endpoint", myRequest).then( /*#__PURE__*/function () {
      var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(res) {
        var updatedPosts;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return res.json();

              case 2:
                updatedPosts = _context.sent;
                Object(swr__WEBPACK_IMPORTED_MODULE_3__[/* mutate */ "b"])("getPosts", updatedPosts);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  } // Deprecated


  function togglePostsEdit() {
    return _togglePostsEdit.apply(this, arguments);
  }

  function _togglePostsEdit() {
    _togglePostsEdit = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              changeEditClicked(!postsEditClicked);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _togglePostsEdit.apply(this, arguments);
  }

  return {
    posts: posts,
    deletePost: deletePost,
    postsEditClicked: postsEditClicked,
    togglePostsEdit: togglePostsEdit
  };
} // Redirects to a published Post

function goToPost(username, postId, onCustomDomain, userHost) {
  if (onCustomDomain) {
    next_router__WEBPACK_IMPORTED_MODULE_4___default.a.push("/" + postId);
  } else {
    if (userHost !== "") {
      next_router__WEBPACK_IMPORTED_MODULE_4___default.a.replace("https://".concat(userHost, "/").concat(postId));
    } else {
      next_router__WEBPACK_IMPORTED_MODULE_4___default.a.push("/[username]/[postId]", "/" + username + "/" + postId);
    }
  }
}
function goToDraft(draftId) {
  next_router__WEBPACK_IMPORTED_MODULE_4___default.a.push("/drafts/[draftId]", "/drafts/" + draftId);
}
function goToPostFromExplore(post) {
  var customDomain = post.customDomain,
      postId = post.postId,
      username = post.username;

  if (post.customDomain) {
    window.location.href = "https://".concat(customDomain, "/").concat(postId);
  } else {
    next_router__WEBPACK_IMPORTED_MODULE_4___default.a.push("/[username]/[postId]", "/" + username + "/" + postId);
  }
}

/***/ })

}]);